<div>
  <form [formGroup]="form" class="mt-3" appPermissionControl="P106F0001">
    <div class="form-row mt-3">
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="empresa" maxlength="50" appPermissionControl="P106K0001" />
        <label>Empresa</label>
      </div>

      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="sucursal" maxlength="50" appPermissionControl="P106K0002" />
        <label>Sucursal</label>
      </div>
    </div>

    <div class="form-row mt-3">
      <div class="form-field flex-grow-1">
        <select class="form-control" formControlName="promocion" appPermissionControl="P106K0003">
          <option value appPermissionControl="P106K0004">Seleccione promoción</option>
          <option *ngFor="let promocion of listPromociones" [value]="promocion.value" appPermissionControl="P106K0005">
            {{ promocion.label }}
          </option>
        </select>
        <label>Promoción *</label>
        <small class="text-danger" *ngIf="formValue('promocion')?.errors?.required && formValue('promocion')?.touched"> La promoción es requerida </small>
      </div>
    </div>

    <div class="button-section mt-3">
      <button mat-flat-button type="submit" [disabled]="!form.valid || loading" class="btn-success" (click)="create(form.value)" appPermissionControl="P106B0001">
        <mat-icon>save</mat-icon>
        {{ loading ? (modelRecived ? 'Actualizando...' : 'Guardando...') : modelRecived ? 'Actualizar' : 'Guardar' }}
      </button>
    </div>
  </form>
</div>

<style>
  .form-control.ng-invalid.ng-touched {
    border-color: #dc3545;
  }

  .form-control.ng-invalid.ng-touched + label {
    color: #dc3545;
  }

  .text-danger {
    font-size: 0.75rem;
    margin-top: 0.25rem;
  }

  [disabled] {
    cursor: not-allowed;
  }
</style>
